/**
 * Create Loader Instance. This contains most of the plumbings of the loader component, but with the cache and url details
 * abstracted away
 */

'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _ajax = require('./ajax');

var ajaxLoader = _interopRequireWildcard(_ajax);

exports['default'] = function (languagePackCache, scriptPath, languagePackPath) {

	/**
  * Grab a languagepack from the cache if it exists or
  * via an AJAX call.
  *
  * @param path - the path to the languagepack
  * @return Promise
  */
	function getLanguagepack(path) {

		// first handle cached languagepacks
		var cached = languagePackCache[path];
		if (cached) {
			return Promise.resolve(cached);
		}

		// otherwise just lead them up from the server
		var fullPath = languagePackPath.replace('languagepack', path);
		return ajaxLoader.json(fullPath);
	}

	/**
  * Preload the templates and cache the language pack bundles.
  */
	function preload() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		// don't load dust when we don't need to
		if (!options.dontPreloadDust) {
			ajaxLoader.script(scriptPath);
		}

		// pre-load the messages when we can
		if (options.messages) {
			Object.assign(languagePackCache, options.messages);
			return;
		}

		// Rather than reassign languagePackCache, which drops the object reference, we merge in the content
		ajaxLoader.json(languagePackPath).then(function (content) {
			Object.assign(languagePackCache, content);
		});
	}

	/**
  * Preload the langauge packs
  * @returns A promise that will tell us when the loading is complete
  */
	function preloadLanguagepacks() {
		return ajaxLoader.json(languagePackPath).then(function (content) {

			// Rather than reassign languagePackCache, which drops the object reference, we merge in the content
			Object.assign(languagePackCache, content);
		});
	}

	/**
  * Grab a languagepack from the cache if it exists or
  * via an AJAX call.
  *
  * @param path - the path to the languagepack
  * @param callback - the callback you want
  */
	function languagepack(path, callback) {
		return getLanguagepack(path).then(callback);
	}

	/**
  * Grab some number of languagepacks from the cache if they
  * exit or do some AJAX calls for them.
  */
	function languagepacks(paths, callback) {

		// create an array of promises of ajax calls
		var ajaxCalls = paths.map(function (path) {
			return getLanguagepack(path);
		});

		// collect all the languagepacks into an array
		Promise.all(ajaxCalls).then(function (messages) {

			// if we only pulled a single properties file
			if (ajaxCalls.length === 1) {
				return callback(messages[0]);
			}

			// combine all of the responses into a single object
			var allMessages = messages.reduce(function (prev, curr) {
				Object.assign(prev, curr[0]);
				return prev;
			}, {});

			callback(allMessages);
		});
	}

	/**
  * Override the language path something not provided by data-template-path
  * @param pathOverride {String} - Language Path Url
  */
	function overrideLanguagePackPath(pathOverride) {
		// languagepack is expected to be in the string (otherwise getLanguagepack() doesn't return a file)
		if (!pathOverride.includes('languagepack')) {
			return;
		}
		languagePackPath = pathOverride;
	}

	return {
		preload: preload,
		preloadLanguagepacks: preloadLanguagepacks,
		languagepack: languagepack,
		languagepacks: languagepacks,
		overrideLanguagePackPath: overrideLanguagePackPath
	};
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/forklifter/dist/createLoader.js
 ** module id = 186
 ** module chunks = 0 1 2 3 4 5 6
 **/